import styled, { css, DefaultTheme } from 'styled-components';
import { NuggetToggleMode } from 'src/utils/nuggetExpanded';

const trackColor = (
  value: NuggetToggleMode,
  disabled: boolean | undefined,
  theme: DefaultTheme,
) => {
  if (disabled) {
    if (value === 'off') {
      return theme.co.neutral95;
    }

    return value === 'on' ? theme.co.success95 : theme.co.success70;
  }

  if (value === 'off') {
    return theme.co.neutral90;
  }

  return value === 'on' ? theme.co.success80 : theme.co.success50;
};

const trackPadding = (value: NuggetToggleMode, theme: DefaultTheme) => {
  if (value === 'off') {
    return css`
      padding-left: 0;
      padding-right: ${theme.sz.s4};
    `;
  }

  if (value === 'on') {
    return css`
      padding-left: ${theme.sz.s2};
      padding-right: ${theme.sz.s2};
    `;
  }

  return css`
    padding-left: ${theme.sz.s4};
    padding-right: 0;
  `;
};

export const Container = styled.div(
  () => css`
    position: relative;
    display: inline-block;
    flex-shrink: 0;
  `,
);

export const Button = styled.button<{ $value: NuggetToggleMode }>(
  ({ theme, $value, disabled }) => css`
    appearance: none;
    border: none;
    display: block;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    background-color: ${trackColor($value, disabled, theme)};
    border-radius: ${theme.bo.round};
    transition:
      padding 0.2s,
      background-color 0.2s;
    ${trackPadding($value, theme)};

    &:focus-visible {
      box-shadow: 0 0 0 3px ${theme.co.information50};
    }
  `,
);

export const Thumb = styled.span(
  ({ theme }) => css`
    display: block;
    box-sizing: border-box;
    border-radius: ${theme.bo.round};
    height: ${theme.sz.s8};
    width: ${theme.sz.s8};
    border: ${theme.bo.mediumWidth} solid transparent;
    background-color: ${theme.co.neutral99};
    background-clip: content-box;
    box-shadow: ${theme.sh.s2};

    button:disabled & {
      box-shadow: unset;
    }
  `,
);
